import { APIRequestType, FilterConfigType } from './filters'
import { analyticsApiRequestType } from '../utils/constants'

export type GenericAnalyticsWidgetUIConfigType = {
  id: string
  positionX: number
  orientation: string
  positionY: number
  title: string
  lineMetricList?: Array<AnalyticsMetricType>
  primaryMetricList?: Array<AnalyticsMetricType>
  secondaryMetricsList?: Array<AnalyticsMetricType>
  detailedMetricsList?: Array<Array<AnalyticsMetricType>>
  chartData?: {
    current: any[]
    comparison: any[]
  }
}

export type LineDistributionItemType = {
  share: number
  title: string
  label: React.ReactNode
}

export type LineDistributionConfigType = {
  distributionItems: LineDistributionItemType[]
}

export type multipleRequestEndpointType = {
  url: string
  baseURL: string
  requestType: analyticsApiRequestType.GET | analyticsApiRequestType.POST
  payload?: string | Record<string, any>
}

export type GenericAnalyticsWidgetDataRequestType = {
  endpoints: multipleRequestEndpointType[]
  filters: FilterConfigType
  parser: (response: any, uiConfig: GenericAnalyticsWidgetUIConfigType) => GenericAnalyticsWidgetUIConfigType
}

export enum AnalyticsEntityType {
  CART_ANALYTICS = 'CART_ANALYTICS',
  UPSELL_ANALYTICS = 'UPSELL_ANALYTICS'
}

export type GenericAnalyticsWidgetType = {
  uiConfig: GenericAnalyticsWidgetUIConfigType
  requestConfig: GenericAnalyticsWidgetDataRequestType
  customClass?: string
  timeScale?: string
  lineConfig?: (widgetData: any) => any
  analyticsEntity?: AnalyticsEntityType
}

export type CartMilestoneType = {
  milestoneHeader: string
  amount: number | string
}

export type MilestoneOnCartType = {
  uiConfig: GenericAnalyticsWidgetUIConfigType
  requestConfig: GenericAnalyticsWidgetDataRequestType
  widgetData?: CartMilestoneType[]
}

export type CompareStatusType = 'increased' | 'decreased' | 'equal'

export type AnalyticsMetricType = {
  title: string
  value: string | number | number[] | LineDistributionConfigType
  type: 'AMOUNT' | 'PERCENTAGE' | 'TIME' | 'NUMBER' | 'LIST' | 'LINE_DISTRIBUTION_CONFIG_TYPE' | 'STRING'
  description?: string
  compareValue?: number | string
  comparePercentage?: number
  compareStatus?: CompareStatusType
  header?: string
}
export type productDetails = {
  product_id: string
  title: string
  order_count: string
  image: string
}
